import actionTypes from './actionTypes';

const resetPlayersAndTeamsState = (state) => ({
    type: actionTypes.RESET_PLAYERS_AND_TEAMS_STATE,
    payload: {
        state,
    },
});

const showLegend = (flag) => ({
    type: actionTypes.SHOW_LEGEND,
    payload: {
        flag,
    },
});

export default {
    resetPlayersAndTeamsState,
    showLegend,
};
